import NoEKGPreview from './NoEKGPreview'

export default NoEKGPreview
